<template>
  <div class="doc-header">
    <!-- 左侧 -->
    <div class="header-left">
      <img
        src="@/assets/icons/i-return.png"
        style="width: 36px; height: 36px; cursor: pointer"
        @click="handleBack"
      />
      <span class="doc-title">
        {{ title }}
      </span>

      <span class="save-status" v-if="saveText">
        <CheckCircleFilled class="success-icon" />
        自动保存于 {{ saveText }}
      </span>
    </div>

    <!-- 右侧 -->
    <div class="header-right">
      <!-- 生成文档 -->
      <a-button class="generate-btn" :disabled="!ready" @click="handleGenerate">
        ▧ 保存诉状
      </a-button>

      <!-- 下载Word -->
      <a-button
        type="primary"
        class="download-btn"
        :disabled="!ready"
        @click="download"
      >
        <DownloadOutlined />

        下载 Word
      </a-button>
    </div>
  </div>
</template>

<script setup>
import { CheckCircleFilled, DownloadOutlined } from "@ant-design/icons-vue";

defineProps({
  title: {
    type: String,
    default: "",
  },

  saveText: {
    type: String,
    default: "",
  },

  version: {
    type: String,
    default: "1",
  },

  // 文书是否已生成（编辑器就绪）：保存诉状/下载 Word 依赖编辑器里有文档
  ready: {
    type: Boolean,
    default: true,
  },
});

const emit = defineEmits(["generate", "download", "save", "back"]);

const handleBack = () => {
  emit("back");
};

const download = () => {
  emit("download");
};

const handleGenerate = () => {
  emit("generate");
};
</script>

<style scoped>
.doc-header {
  height: 50px;
  padding: 0 18px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  background: #fff;
}

/* 左侧 */

.header-left {
  display: flex;
  align-items: center;
}

.back-btn {
  display: inline-flex;
  width: 30px;
  height: 30px;
  margin-right: 12px;
  align-items: center;
  justify-content: center;
  padding: 0;
  font-size: 16px;
  flex-shrink: 0;
  transition: border-color 0.15s, color 0.15s, background 0.15s;
}

.doc-title {
  font-size: 16px;
  font-weight: 600;
  margin-left: 10px;
  color: #24324b;
}

.save-status {
  margin-left: 10px;
  font-size: 12px;
  color: #7b8495;
  display: flex;
  align-items: center;
}

.success-icon {
  color: #52c41a;
  margin-right: 5px;
  font-size: 14px;
}

/* 右侧 */

.header-right {
  display: flex;
  align-items: center;
  gap: 10px;
}

.generate-btn {
  height: 32px;
  border-radius: 8px;
  color: #31425f;
}

.version {
  margin-left: 4px;
}

.download-btn {
  height: 32px;
  border-radius: 8px;
  background: #1768ff;
  box-shadow: 0 4px 10px rgba(23, 104, 255, 0.25);
}
</style>
